import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { modals } from '@modals';
import { useStore, useGetter } from '@store';
import { computeDisplayName } from '@utils/user';
import { auth, RoleId } from '@auth';

import { faArrowCircleDown } from '@icons/solid/faArrowCircleDown';

import profileImage from '@assets/images/portrait_las.png';
import profileBorder from '@assets/images/bronze_rank.png';

import SidebarNav from './SidebarNav.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const store = useStore();

const activeRole = useGetter('activeRole');
const selectableRoles = useGetter('me/selectableRoles');

const me = computed(() => store.state.me);

const organization = computed(() => {
  if (me.value.organization) return me.value.organization;
  return null;
});

const isInstitutionAdmin = computed(() => {
  return auth.isActiveRole(RoleId.InstitutionAdmin);
});

const profileName = computed(() => computeDisplayName(me.value));

const hasMultipleRoles = computed(() => selectableRoles.value.length > 1);

const downloadLinks = computed(() => {
  return store.state.launcherLinks.map((item, key) => ({ ...item, key }));
});

const billingType = computed(() => {
  if (!isInstitutionAdmin?.value || !organization?.value) return null;

  if (organization.value.billingType === 'BillMeLater') return 'Billed';
  if (organization.value.billingType === 'POT') return 'Point of Transaction';
  if (organization.value.billingType === 'StudentPays') return 'Student Pays';
  if (organization.value.billingType === 'SiteLicense')
    return organization.value.licensingMethod
      ? `Site License (${organization.value.licensingMethod})`
      : 'Site License';

  return null;
});

const isK12 = computed(() => {
  return !!auth.user?.isK12;
});

function openUserSettings() {
  void modals.account.settings();
}

function openRoleSelect() {
  void modals.account.selectRole();
}

return { __sfc: true,store, activeRole, selectableRoles, me, organization, isInstitutionAdmin, profileName, hasMultipleRoles, downloadLinks, billingType, isK12, openUserSettings, openRoleSelect, faArrowCircleDown, profileImage, profileBorder, SidebarNav }
}

})